import { forEach, isObject } from 'lodash';

/**
 * Search for a given string in an array with objects. Used to find a string
 * Example: Used to find a string in an table with accountants or clients
 *
 * @param {String} searchString
 * @param {array} searchInArray
 * @param {array} searchInColumns
 * @returns array
 */
export function searchStringInArray(searchString, searchInArray, searchInColumns) {
  const filteredData = searchInArray.filter(row => {
    let match = false;

    forEach(searchInColumns, column => {
      if (!row[column]) {
        return;
      }

      let stringIncluded = false;
      const currentValue = row[column].toString();
      const lowercaseValue = currentValue.toLowerCase();
      stringIncluded = lowercaseValue.includes(searchString);

      if (stringIncluded) {
        match = true;
      }
    });

    return match ? row : false;
  });

  return filteredData;
}

/**
 * Get object size
 *
 * @param {Object} obj
 * @returns {int}
 */
export function getObjectSize(obj) {
  let size = 0;

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      size++;
    }
  }

  return size;
}

/**
 * Source: https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
 */
export function guid() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}

/**
 * Get chart data
 * @param {Object} obj
 * @param {Object} colors
 */
export function getChartDataSet(obj, colors) {
  return {
    label: obj.displayName,
    borderColor: colors.borderColor,
    backgroundColor: colors.backgroundColor,
    fill: 'start',
    data: obj.values
  };
}

/**
 * Handle properties with relation to other DBs
 * Remove properties that are not array or object
 * @param {Object} payload  Object to transform
 * @param {Array} relationalProps List of properties to remove
 */
export function getDataWithoutProperties(payload, relationalProps) {
  const data = Object.assign({}, payload);
  for (let [key, value] of Object.entries(data)) {
    if (relationalProps.includes(key)) {
      if (!isObject(value)) {
        // Remove properties that are no arrays or objects
        delete data[key];
      }
    }
  }

  return data;
}

/**
 * Remove the object and use the object name as key and the object id as value
 * This is neccessary to update/create relations in directus
 *
 * @param {Array} payload
 */
export function getDataWithOnlyIntegerRelation(payload) {
  const result = [];

  payload.forEach(value => {
    const relation = {};
    if (isObject(value)) {
      for (let [relationKey, relationValue] of Object.entries(value)) {
        if (isObject(value) && relationValue.hasOwnProperty('id')) {
          // Save the id in the object as integer value
          relation[relationKey] = relationValue.id;
        } else {
          // No transformation, just save the original value
          relation[relationKey] = relationValue;
        }
      }
    }

    result.push(relation);
  });

  return result;
}
